<script setup>
import { createApp, h, ref } from 'vue'
import DataTable from './datatable/DataTable.vue'
import { Button } from "@/components/ui/button"
import { get_data_attr } from '@/utils/globals'
import { useI18n } from 'vue-i18n';
import { Logs} from "lucide-vue-next";


const { t } = useI18n();
const specsInfo = get_data_attr("specs");
const specsTypesInfo = get_data_attr("spectypes");

const selectedId = ref(null)
const selectedRoleId = ref(null)
const selectedDetails = ref([])

function setSelected(row) {
	selectedRoleId.value = row.idid;
	selectedDetails.value = row["logdetails"]
}

const logdetailscols= [{key: "field", label: "Feld", show: true}, {key: "from", label: "Vorher", show: true}, {key: "to", label: "Nachher", show: true}]
</script>

<template>
	
<div class="flex h-screen w-full">
  <div class="flex w-2/3 p-4 gap-4">
	 <div class="sflex-1">
		<DataTable
		  		 label="view.logs"  :logo="rkIconUrl" endpoint="logs"
		 		 :columns="specsInfo['logs']"
				 :enableAdd="false"
				 :enableDelete="false"
				 :enableEdit="false">
		  <template #logo><Logs /></template>
		  <template #extraactions="{row}">
		    <Button :id="'logdetails-' + row.id"
		      :title="t('view.btn_logdetails')" 
		      size="icon" 
		      variant="ghost" 
		      class="text-green-600 hover:bg-blue-50" 
		      @click="() => setSelected(row)"
		    >
		      <Logs class="w-4 h-4" />
		    </Button>
		  </template>
		</DataTable>
     </div>
	 <div class="flex-1">
	   <DataTable label="view.logdetails"
	             :logo="rkIconUrl" :data="selectedDetails"
	 	     :columns="logdetailscols"
	 		 :enableAdd="false"
	 		 :enableDetail="false"
			 :enableEdit= "false"
	 		 :enableDelete="false">
	   </DataTable>
	 </div>

   </div>
</div>
</template>
